import type { InstitutionTheme } from '../types';
import { deanzaColors } from './colors';

// De Anza College institutional theme (W48 Worker A, S3 step 4).
//
// Brand strings from the college site; "MyPortal" is the Foothill–De Anza
// student portal (registration, records — the site's own login label).
// Colors per ./colors.ts (Maroon + Gold, first-party CSS variables).
//
// Example course codes are the three code SHAPES the S0 probe walk found
// (probes/course_index_s0.json): MATH 1A (letter-suffixed student-facing code),
// ENGL C1000 (AB 1111 Common Course Number, C form — the arbitrated canonical),
// F/TV 2A (the slash-prefix department). First entry is the primary example.
export const deanzaTheme: InstitutionTheme = {
  slug: 'deanza',
  universityName: 'De Anza College',
  universityShortName: 'De Anza',
  registrationPortalName: 'MyPortal',
  exampleCourseCodes: ['MATH 1A', 'ENGL C1000', 'F/TV 2A'],
  colors: deanzaColors,
};
